import { render, staticRenderFns } from "./EditPhieuSuaChua.vue?vue&type=template&id=f0985d5a"
import script from "./EditPhieuSuaChua.vue?vue&type=script&lang=js"
export * from "./EditPhieuSuaChua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports